// --- components/Navbar.tsx ---
'use client'
import React from "react";
import { usePathname } from "next/navigation";
import { Button } from "../ui/button";
import { Sheet,SheetClose, SheetContent,  SheetHeader, SheetTitle, SheetTrigger } from "../ui/sheet";
import Link from "next/link";

// This component defines the responsive navigation bar for Samsan Industrial Supply.
interface NavLink {
  name: string;
  href: string;
}

const Navbar: React.FC = () => {
  const pathname = usePathname();

  // Navigation links
  const navLinks: NavLink[] = [
    { name: 'Home', href: '/' },
    { name: 'Brands', href: '/brands' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
    { name: 'FAQ', href: '/faq' },
  ];

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link href="/" className="text-3xl font-bold text-gray-900">
          Samsan <span className="text-yellow-600">Inc.</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          {navLinks.map((link: NavLink) => (
            <Link
              key={link.name}
              href={link.href}
              className={`font-medium transition-colors duration-200 ${pathname === link.href ? "text-yellow-600" : "text-gray-700 hover:text-yellow-600"}`}
            >
              {link.name}
            </Link>
          ))}
          <Link href="/contact">
          <Button variant="default" className="bg-yellow-600 cursor-pointer hover:bg-yellow-700 text-white rounded-md px-6 py-2">
            Get a Quote
          </Button>
          </Link>
        </div>

        {/* Mobile Navigation (Hamburger Icon) */}
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger>
              {/* Hamburger Icon SVG */}
              <svg
                className="h-6 w-6 text-gray-700 cursor-pointer"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </SheetTrigger>
            <SheetContent side="right" className="w-3/4 sm:w-1/2 bg-white flex flex-col">
                <SheetHeader className="pb-4 border-b">
                  <SheetTitle>Samsan inc.</SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col space-y-4 mt-6 flex-grow items-center">
                  {navLinks.map((link: NavLink) => (
                    <SheetClose key={link.name} asChild>
                      <Link
                        href={link.href}
                        className={`text-lg font-medium transition-colors duration-200 block py-2 ${pathname === link.href ? "text-yellow-600" : "text-gray-800 hover:text-yellow-600"}`}
                      >
                        {link.name}
                      </Link>
                    </SheetClose>
                  ))}
                </nav>
                <SheetClose asChild className="mt-auto pt-4 pb-4 border-t">
                  <Link href="/contact">
                    <Button variant="default" className="w-full bg-yellow-600 hover:bg-yellow-700 text-white rounded-md py-3 font-semibold shadow-lg transition-all duration-300 mb-4 mx-4">
                      Get a Quote
                    </Button>
                  </Link>
                </SheetClose>
              </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;